export enum MerchandiseSlotId {
  MarketingLabelProducts = 'marketing-label-products',
}
